import React, { Component } from 'react'
import { HeaderBar, Button, FormWrapper, FormColumn } from 'modules/theme';
import PropTypes from 'prop-types';
import { Item, Items, ProfileBar, RightPart, TopBar, Avatar, AgentName, ActiveSign, Sign, LeftPart, BadgeButton } from '../styles/dialpadstyle';
import { Badge, Dropdown } from 'react-bootstrap';
import DropdownToggle from './DropdownToggle';
import { AiOutlineMore } from 'react-icons/ai';

export class HeaderDialpad extends Component {

  renderHeaderOffline() {
    const { more, isBack, onBackBtn, close, showPreview, profile, isProfile, headerTitle, background, subState, isFullProfile, state, sign, dropDownList, onCloseClick, previewBtnClick, previewBtn, previewCnt, isConnected } = this.props;
    const { __ } = this.context;
    return (
      <HeaderBar background={background}>
        <TopBar>
          {(!isProfile && !isFullProfile) &&
            <AgentName style={{ "marginLeft": "20px", "marginTop": "10px" }}>
              {headerTitle}
            </AgentName>
          }
          <LeftPart>
            <Items>
              {isBack &&
                <Item
                  style={{
                    "padding": "8px",
                    "background": "#4784ca",
                    "marginTop": "2px",
                    "marginRight": "20px",
                    "borderRadius": "4px",
                  }}
                  onClick={onBackBtn}>
                  <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5.27796 1.28269C5.57216 0.991107 5.57427 0.516238 5.28269 0.222041C4.99111 -0.0721558 4.51624 -0.0742744 4.22204 0.217309L2.42731 1.9961C1.75134 2.66604 1.19886 3.21359 0.807056 3.70146C0.399628 4.20878 0.104695 4.72372 0.0259091 5.34184C-0.00863636 5.61286 -0.0086363 5.88714 0.0259089 6.15816C0.104695 6.77628 0.399628 7.29122 0.807057 7.79854C1.19886 8.28641 1.75133 8.83395 2.4273 9.50389L4.22204 11.2827C4.51624 11.5743 4.99111 11.5722 5.28269 11.278C5.57427 10.9838 5.57216 10.5089 5.27796 10.2173L3.51499 8.47C2.7995 7.76086 2.30869 7.27282 1.97659 6.85929C1.654 6.4576 1.54332 6.19958 1.51387 5.9685C1.49538 5.82341 1.49538 5.67659 1.51387 5.5315C1.54332 5.30042 1.654 5.0424 1.97659 4.64071C2.30869 4.22718 2.7995 3.73914 3.51499 3.03L5.27796 1.28269Z" fill="white" />
                  </svg>
                </Item>
              }
            </Items>

          </LeftPart>
          <RightPart>
            <Items>
              {isConnected && showPreview &&
                <Item>
                  <BadgeButton>
                    <Button btnStyle="filter" size="small" onClick={previewBtnClick}>
                      {previewBtn}  <Badge bg="secondary">{previewCnt}</Badge>
                    </Button>
                  </BadgeButton>
                </Item>
              }

              <Item>
                <Dropdown id="dropdown-engage">
                  <DropdownToggle bsRole="toggle">
                    <Button btnStyle="simple" size="small">
                      {more}
                    </Button>
                  </DropdownToggle>
                  <Dropdown.Menu style={{ left: "-50px" }}>
                    {dropDownList}
                  </Dropdown.Menu>
                </Dropdown>
              </Item>
              <Item onClick={onCloseClick}>
                {close}
              </Item>
            </Items>
          </RightPart>
        </TopBar>
        <ProfileBar>
          {isProfile &&
            <React.Fragment>
              <Avatar>
                <img style={{ "borderRadius": "50%", "width": "50px", "height": "50px" }} src={profile} />
              </Avatar>
              <AgentName>
                {headerTitle}
                {subState && <div style={{ "margin-top": "10px" }}>{subState}</div>}
              </AgentName>
            </React.Fragment>
          }
        </ProfileBar>
        {isFullProfile &&
          <FormWrapper>
            <FormWrapper style={{ "marginTop": "20px", "height": "60px" }}>
              <FormColumn>
                <Avatar>
                  {/* <img src={profile} /> */}
                </Avatar>
              </FormColumn>
            </FormWrapper>
            <FormWrapper>
              <FormColumn>
                <AgentName>
                  {headerTitle}
                  {subState && <div style={{ "margin-top": "10px" }}>{subState}</div>}
                </AgentName>
              </FormColumn>
            </FormWrapper>
          </FormWrapper>
        }
      </HeaderBar>
    )
  }
  render() {
    const { typeHeaderOffline, typeHeaderText, typeHeaderCall, isConnected } = this.props;
    const { __ } = this.context;
    // let state = userState.State || '';
    return (
      isConnected ? this.renderHeaderOffline() : this.renderHeaderOffline()
    )
  }
}

HeaderDialpad.propTypes = {
  isConnected: PropTypes.bool.isRequired
};

HeaderDialpad.contextTypes = {
  __: PropTypes.func
};

export default HeaderDialpad


// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/components/HeaderDialpad.js